import { useAppDispatch, useAppSelector } from 'app/config/store';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { DESC, ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import React, { useEffect, useState } from 'react';
import { getPaginationState } from 'react-jhipster';
import { useLocation } from 'react-router-dom';
import { Container } from 'reactstrap';

import { Input, Space, Switch } from 'antd';
import Title from 'antd/es/typography/Title';
import TableComponent from 'app/shared/component/table/table';
import { closeOrOpen, getEntities } from '../draft-period.reducer';
import { columns } from './config';

const { Search } = Input;

export const DraftPeriod = () => {
  const dispatch = useAppDispatch();
  const pageLocation = useLocation();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'lastModifiedDate', DESC), pageLocation.search),
  );

  const draftPeriodList = useAppSelector(state => state.draftPeriod.entities);

  const [searchText, setSearchText] = useState();

  // config columns, actions add plan period
  const newColumns = [
    ...columns,
    {
      title: 'Tình trạng',
      key: 'isActive',
      render: item => (
        <Switch
          checked={item.isActive}
          onChange={() => {
            handleCloseOrOpen(item);
          }}
          checkedChildren="Mở"
          unCheckedChildren="Đóng"
        />
      ),
    },
  ];

  // end config
  useEffect(() => {
    initial();
  }, []);

  useEffect(() => {
    getAllEntities();
  }, [paginationState.activePage, paginationState.itemsPerPage]);

  const initial = () => {
    getAllEntities();
  };

  const getAllEntities = (value?: string) => {
    dispatch(
      getEntities({
        searchText: value ?? searchText,
        page: paginationState.activePage,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      }),
    );
  };

  const handleChange = (pageNumber: number, size: number, sorter: any) => {
    setPaginationState({
      ...paginationState,
      order: DESC, //sorter.order && OrderByType[sorter.order] === OrderByType.descend ? DESC : ASC,
      sort: sorter.columnKey,
      activePage: pageNumber,
      itemsPerPage: size,
    });
  };

  const handleFreeTextSearchQuery = query => {
    setSearchText(query);
    getAllEntities(query);
  };


  const handleCloseOrOpen = item => {
    item.isActive = !item.isActive;
    dispatch(closeOrOpen(item))
      .then(res => {
        if (res && res.payload) {
          getAllEntities();
        }
      })
      .catch(() => {
        return;
      });
  };

  return (
    <Container className="view">
      <div className="d-flex gap-5">
        <Title level={3}>Danh sách kỳ dự thảo</Title>
      </div>
      <div className="table">
        <div className="header">
          <Space className="search">
            <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
          </Space>
        </div>
        <TableComponent
          data={draftPeriodList.map((x, index) => {
            return {
              key: index + 1,
              ...x,
            };
          })}
          scroll={false}
          total={0}
          isFetching={false}
          columns={newColumns}
          handlePageChange={(pageNumber: number, size: number, search: any, sorter: any) => {
            handleChange(pageNumber, size, sorter);
          }}
        />
      </div>
    </Container>
  );
};

export default DraftPeriod;
